import { apiFetch } from "./http";

// UnansweredQuestion — Mevzuat Analizi'nde yüklü dokümanlarda cevabı bulunamayan soru.
export type UnansweredQuestion = {
  id: number;
  org_id: number;
  org_name?: string;
  question: string;
  model?: string;
  /** Reddin geldiği anda aramanın döndürdüğü kaynak parça sayısı.
   *  0 = corpus boşluğu (doküman ekle) · >0 = model reddi (kaynak vardı)
   *  · undefined = ölçüm eklenmeden önce yazılmış eski kayıt. */
  chunks_used?: number | null;
  times_asked: number;
  first_asked: string;
  last_asked: string;
  resolved_at?: string | null;
};

async function jsonOrThrow<T>(res: Response, fallback: string): Promise<T> {
  if (!res.ok) {
    let msg = `${fallback} (HTTP ${res.status})`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
  return res.json();
}

async function okOrThrow(res: Response, fallback: string): Promise<void> {
  if (!res.ok) {
    let msg = `${fallback} (HTTP ${res.status})`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
}

export async function listUnanswered(openOnly = false): Promise<UnansweredQuestion[]> {
  const qs = openOnly ? "?open=true" : "";
  const res = await apiFetch(`/api/v1/admin/unanswered${qs}`);
  const data = await jsonOrThrow<{ items: UnansweredQuestion[] | null }>(res, "Cevapsız sorular alınamadı");
  return data.items ?? [];
}

// resolveUnanswered — çözüldü işaretle (bu soruya uygun doküman corpus'a eklendi).
export async function resolveUnanswered(id: number): Promise<void> {
  const res = await apiFetch(`/api/v1/admin/unanswered/${id}`, { method: "PATCH" });
  await okOrThrow(res, "Çözüldü işaretlenemedi");
}

export async function deleteUnanswered(id: number): Promise<void> {
  const res = await apiFetch(`/api/v1/admin/unanswered/${id}`, { method: "DELETE" });
  await okOrThrow(res, "Silinemedi");
}

// ── Soru günlüğü ────────────────────────────────────────────────────────────
//
// UnansweredQuestion ile karıştırma: o dedupe'lı corpus iş listesi
// (times_asked + "Çözüldü"), bu ham günlük — her soruş bir satır.
// source 'web' ise org_id/org_name BOŞTUR: tanıtım sitesindeki demo girişsiz
// çalışır, müşteri bilgisi yoktur.
export type QuestionLog = {
  id: number;
  org_id?: number | null;
  org_name?: string;
  source: "panel" | "web";
  ip?: string;
  /** Ham User-Agent başlığı. Tabloda ortamCoz() ile okunabilir özete
   *  çevrilir; ham metin title'da kalır çünkü ayrıştırıcı yeni bir tarayıcıyı
   *  tanımadığında bakılacak tek kaynak odur.
   *  Boş = başlık gönderilmemiş ya da ölçüm eklenmeden (2026-08-18) önceki kayıt. */
  user_agent?: string;
  question: string;
  answered: boolean;
  chunks_used?: number | null;
  model?: string;
  created_at: string;
};

export type QuestionLogPage = {
  items: QuestionLog[];
  total: number;
  page: number;
  per_page: number;
};

/** answered verilmezse iki durumun toplamı döner. */
export async function listQuestions(
  opts: { answered?: boolean; page?: number; perPage?: number } = {},
): Promise<QuestionLogPage> {
  const p = new URLSearchParams();
  if (opts.answered !== undefined) p.set("answered", String(opts.answered));
  if (opts.page) p.set("page", String(opts.page));
  if (opts.perPage) p.set("per_page", String(opts.perPage));
  const res = await apiFetch(`/api/v1/admin/questions?${p.toString()}`);
  const d = await jsonOrThrow<QuestionLogPage>(res, "Soru günlüğü alınamadı");
  return {
    items: d.items ?? [],
    total: d.total ?? 0,
    page: d.page ?? 1,
    per_page: d.per_page ?? 50,
  };
}
